import { useEffect, useState, useRef, useCallback } from 'react';

export default function MotivationalBanner({ phrases = [], random = true, intervalSeconds = 30, className = '' }) {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isVisible, setIsVisible] = useState(true);
    const intervalRef = useRef(null);

    const activePhrases = phrases.filter(Boolean);

    const getNextIndex = useCallback((prevIndex) => {
        if (activePhrases.length <= 1) return 0;
        if (random) {
            let next;
            do {
                next = Math.floor(Math.random() * activePhrases.length);
            } while (next === prevIndex && activePhrases.length > 1);
            return next;
        }
        return (prevIndex + 1) % activePhrases.length;
    }, [activePhrases.length, random]);

    useEffect(() => {
        if (activePhrases.length <= 1) return;

        const intervalMs = (intervalSeconds || 30) * 1000;

        intervalRef.current = setInterval(() => {
            setIsVisible(false);
            setTimeout(() => {
                setCurrentIndex(prev => getNextIndex(prev));
                setIsVisible(true);
            }, 500); // Wait for fade-out before switching
        }, intervalMs);

        return () => clearInterval(intervalRef.current);
    }, [activePhrases.length, intervalSeconds, getNextIndex]);

    if (activePhrases.length === 0) return null;

    return (
        <div className={`bg-white/5 border border-white/10 rounded-lg px-4 py-3 text-center ${className}`}>
            <p
                className={`text-sm text-white/80 italic transition-opacity duration-500 ease-in-out ${isVisible ? 'opacity-100' : 'opacity-0'}`}
            >
                &ldquo;{activePhrases[currentIndex]}&rdquo;
            </p>
        </div>
    );
}
